import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const TopRequested = lazy(() => import("modules/test-requests/TopRequested"));
export default function TopRequestedPage() {
  return (
    <SuspenseWrapper>
      <TopRequested />
    </SuspenseWrapper>
  );
}
